/* TUZEX odpočet do konca akcie: <tx-countdown data-end="2026-11-30T23:59:59+01:00">…</tx-countdown>
   Po skončení akcie schová element s [data-tx-countdown-hide] (alebo sám seba). */
(() => {
  if (customElements.get('tx-countdown')) return;
  const pad = (n) => String(n).padStart(2, '0');
  customElements.define('tx-countdown', class extends HTMLElement {
    connectedCallback() {
      this.end = Date.parse(this.dataset.end || '');
      this.out = this.querySelector('[data-tx-countdown-value]') || this;
      this.withSeconds = this.dataset.seconds === 'true';
      if (!this.end) return;
      this.tick();
      this.timer = setInterval(() => this.tick(), this.withSeconds ? 1000 : 15000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    tick() {
      const left = this.end - Date.now();
      const hideTarget = this.closest('[data-tx-countdown-hide]') || this;
      if (left <= 0) { hideTarget.hidden = true; clearInterval(this.timer); return; }
      hideTarget.hidden = false;
      const d = Math.floor(left / 864e5), h = Math.floor(left / 36e5) % 24, m = Math.floor(left / 6e4) % 60, s = Math.floor(left / 1e3) % 60;
      let text;
      if (d > 0) text = `${d} d ${h} h`;
      else if (h > 0) text = `${h} h ${pad(m)} min`;
      else text = this.withSeconds ? `${m} min ${pad(s)} s` : `${Math.max(1, m)} min`;
      if (this.out.textContent !== text) this.out.textContent = text;
      this.setAttribute('aria-label', 'Do konca akcie zostáva ' + text);
    }
  });
})();
